//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import {
    editProcessPermissions,
    publishAppPermissions
} from "@/assets/js/appFunc";
import { diff } from "deep-object-diff";
import { uid } from "quasar";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import QfMInterfaceDetails from "../modals/qf-m-interface-details.vue";
import InterfaceLoad from "../mixins/interface-load";
import InterfaceUtils from "../mixins/interface-utils";

export default {
    name: "QfScreens",
    components: { QfMInterfaceDetails, AQDialog },
    mixins: [InterfaceLoad, InterfaceUtils],
    data() {
        return {
            showSearch: false,
            searchText: null,
            treeThumb: {
                right: "-3px", borderRadius: "2px", width: "3px", opacity: 0.4
            },
            selected: null,
            modalInterfaceDetails: false,
            deleteNode: false,
            hasFragments: false,
            interfaceData: null,
            interfaceName: null,
            setDiffsInterval: null,
            importedInterfaceName: null,
            importedData: null,
            nodeSelected: 0,
            expanded: ["gui"],
            draft: false,
            openDialog: false,
            addClick: 0,
            node: null,
            hasChanges: null,
            deleteAlert: false
        };
    },

    computed: {
        ...mapState("components", ["readOnly", "currentInterfaceProperties", "loadingInterfaces", "currentInterfaceModel", "appInterfaces",
            "activeComponent", "activeInterface", "properties", "emptyInterface"]),
        ...mapState("main", ["interfaceDirty"]),
        ...mapGetters("components", ["body"]),
        ...mapGetters("documentEditor", ["appWasUpdated"]),
        ...mapGetters("apps", ["currentApp", "processList", "getCurrentAppUserPermissions"]),
        treeData() {
            const sources = {
                gui: { list: [], icon: "mdi-window-maximize" },
                fragment: { list: [], icon: "mdi-image-size-select-small" }
            };
            const localTreeData = [
                {
                    name: this.$t("userInterface.interfaces"),
                    children: sources.gui.list,
                    header: "root",
                    icon: "mdi-folder",
                    id: "gui",
                    isLoading: this.loadingInterfaces
                },
                {
                    name: this.$t("userInterface.fragments"), children: sources.fragment.list, header: "root", icon: "mdi-folder", id: "fragment"
                }
            ];

            (this.appInterfaces || []).forEach(interfaceEntry => {
                if (interfaceEntry) {
                    const { id, name, type } = interfaceEntry;
                    const lowerType = type.toLowerCase();
                    const source = sources[lowerType];

                    if (lowerType === "fragment") {
                        this.addFragment({ id, data: interfaceEntry });
                    }
                    source.list.unshift({
                        id, name, header: "generic", icon: source.icon, handler: this.nodeClick
                    });
                }
            });

            return localTreeData;
        },
        messageDialog() {
            let message = "";
            if (this.importedInterfaceName) {
                message = this.importedInterfaceName + this.$t("userInterface.hasFragments");
            } else if (this.currentInterfaceProperties && this.currentInterfaceProperties.name) {
                message = this.currentInterfaceProperties.name + this.$t("userInterface.hasFragments");
            }
            return message;
        },
        readonlyPermission() {
            return this.$route.params && this.$route.params.permissions && this.$route.params.permissions.readonly;
        }
    },
    created() {
        this.$root.$on("draft", value => {
            this.draft = value;
        });

        this.$root.$on("deletedInterface", () => {
            this.$refs.pop.hide();
        });

        this.$root.$on("bc__interfaces__open", this.crumbOpen);

        this.$root.$on("refreshInterface", () => {
            if (this.currentInterfaceProperties.commitId) {
                const payload = {
                    guid: this.currentInterfaceProperties.id,
                    update: true
                };

                this.loadInterface(payload);
            } else {
                this.setActiveInterface(null);
                this.$store.commit("components/removeAppInterface", null);
            }
        });
        this.setReadonly(true);
    },
    mounted() {
        if (!this.processList.length) {
            this.getAppProcesses({ applicationId: this.currentApp.id, searchTerm: "" }).then(rsp => {
                if (rsp.data) {
                    this.$store.commit("apps/setProcessList", rsp.data);
                }
            });
        }
        this.checkForDiifs();
        this.$refs.uploadScreens.addEventListener("change", this.screensPopoverFileInput);
    },
    activated() {
        if (this.currentInterfaceProperties.name) {
            this.nodeClick(this.currentInterfaceProperties);
        }
        this.draft = false;
        this.focusSelectedInterface();
        this.$root.$emit("showPublish", { noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses")
            ? !this.currentApp.nrOfProcesses : !this.processList.length,
        showPublish: this.publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
    },
    beforeDestroy() {
        this.$root.$off("bc__interfaces__open");

        this.$refs.uploadScreens.removeEventListener("change", this.screensPopoverFileInput);
        clearInterval(this.setDiffsInterval);
    },
    methods: {
        // eslint-disable-next-line max-len
        ...mapMutations("components", ["removeComponent", "setInterfaceModel", "setActiveInterface", "resetInterface", "addFragment", "setReadonly"]),
        ...mapActions("components", ["getInterfaceModel", "guiRemove", "loadFragments", "getCommitId", "getLatestAppInterfaces", "saveInterface",
            "exportInterfaceAction", "importInterface"]),
        ...mapActions("apps", ["getAppProcesses"]),
        editProcessPermissions,
        publishAppPermissions,
        crumbOpen(guid) {
            this.$store.commit("main/setInterfaceDirty", false);
            this.loadInterface({ guid, update: true });
        },
        onSearchClick() {
            this.showSearch = !this.showSearch;
            if (this.showSearch) {
                this.$nextTick(() => {
                    const { searchText } = this.$refs;
                    searchText.focus();
                });
            } else {
                this.searchText = null;
            }
        },
        checkForDiifs() {
            this.setDiffsInterval = setInterval(() => {
                if (this.activeInterface) {
                    const { _details = {}, type, code, name, description } = this.currentInterfaceProperties;
                    const { type: iType, code: iCode, name: iName, description: iDescription } = _details;
                    if (this.activeInterface === "draft") {
                        this.$root.$emit("showCheckedSaveBtn", false);
                    } else if (type !== iType || code !== iCode || name !== iName || ((description || "") !== (iDescription || ""))) {
                        this.$root.$emit("showCheckedSaveBtn", false);
                    } else {
                        const original = this.currentInterfaceModel;
                        let hasDiffs;

                        if (Object.keys(original).length === Object.keys(this.properties).length) {
                            hasDiffs = Object.keys(original).some(entry => {
                                let checkDiffs;
                                if (this.properties.hasOwnProperty(entry)) {
                                    const entryDiffs = diff(original[entry], this.properties[entry]);
                                    checkDiffs = Object.keys(entryDiffs).length > 0;
                                } else {
                                    checkDiffs = true;
                                }

                                return checkDiffs;
                            });
                        } else {
                            hasDiffs = true;
                        }

                        if (hasDiffs) {
                            this.$root.$emit("showCheckedSaveBtn", false);
                        }
                    }
                }
            }, 1500);
        },
        treeFilter(node) {
            const { header, name } = node;
            return header === "root" || name.toLowerCase().includes(this.searchText.toLowerCase());
        },
        screensPopoverFileInput() {
            const files = this.$refs.uploadScreens.files || [];
            if (files.length) {
                this.$loadFile(files[0]).then(data => {
                    const updateData = oldData => {
                        const { interfaceJson } = JSON.parse(oldData);
                        const { components } = interfaceJson;
                        let newData = oldData;

                        Object.keys(components || {}).forEach(key => {
                            newData = newData.replaceAll(key, this.$generateUID());
                        });

                        return newData;
                    };
                    let interfaceData = JSON.parse(updateData(data));
                    if (!interfaceData.hasOwnProperty("interfaceJson")) {
                        const newInterface = {
                            id: uid(),
                            name: "Interface",
                            code: "INTF_0",
                            description: null,
                            type: "GUI",
                            interfaceJson: interfaceData,
                            fragments: []
                        };
                        const keys = Object.keys(newInterface.interfaceJson.components);
                        keys.forEach(key => {
                            if (newInterface.interfaceJson.components[key].__component === "ctrl-fragment") {
                                delete newInterface.interfaceJson.components[key];
                            }
                        });
                        interfaceData = JSON.parse(JSON.stringify(newInterface));
                    }
                    const listOfFragments = [...this.appInterfaces];
                    if (interfaceData.type === "GUI" && interfaceData.fragments.length) {
                        interfaceData.fragments.forEach(fragment => {
                            fragment.code = this.appInterfaces && this.appInterfaces.length
                                ? this.createCodeForInterface(fragment, listOfFragments)
                                : fragment.code;
                            listOfFragments.push(fragment);
                        });
                        interfaceData.code = this.appInterfaces && this.appInterfaces.length
                            ? this.createCodeForInterface(interfaceData, listOfFragments)
                            : interfaceData.code;
                    } else {
                        interfaceData.code = this.appInterfaces && this.appInterfaces.length
                            ? this.createCodeForInterface(interfaceData, this.appInterfaces)
                            : interfaceData.code;
                    }
                    this.importedData = interfaceData;
                    if (interfaceData.fragments.length) {
                        this.importedInterfaceName = interfaceData.name;
                        this.hasFragments = true;
                    } else {
                        this.importInterface(this.importedData).then(() => {
                            this.$root.$emit("fromImport", false);
                            this.getLatestAppInterfaces().then(interfaces => {
                                interfaces.forEach(element => {
                                    if (element.code === this.importedData.code) {
                                        this.setActiveInterface(element.id);
                                    }
                                });
                                const payload = {
                                    guid: this.activeInterface,
                                    update: true
                                };
                                this.$store.commit("components/setReadonly", false);
                                this.loadInterface(payload, true);
                                this.$toast.showNotify({
                                    type: "success",
                                    message: this.$t("userInterface.importInterface"),
                                    code: "qfs-removeIOk",
                                    timeout: 2000
                                });
                            });
                        });
                        this.draft = false;
                        this.importedInterfaceName = "";
                        this.resetFileInput();
                    }
                });
            }
        },
        createCodeForInterface(importFile, totalInterfaces) {
            let codeInterface = null;
            let counter = 0;
            const nameImportFile = importFile.code.split("_")[0];
            totalInterfaces.forEach(element => {
                const elementName = element.code.split("_")[0];
                const elementCode = Number(element.code.split("_")[1]);
                if (nameImportFile === elementName) {
                    if (elementCode >= counter) {
                        counter = elementCode + 1;
                    }
                }
            });
            codeInterface = `${nameImportFile}_${counter}`;
            return codeInterface;
        },
        resetFileInput() {
            const { uploadScreens } = this.$refs;
            uploadScreens.type = "";
            this.$nextTick(() => { uploadScreens.type = "file"; });
        },
        importInterfaceMethod() {
            if (!this.readonlyPermission) {
                this.validateChangeAction().then(data => {
                    if (data) {
                        this.$root.$emit("fromImport", true);
                        this.$refs.uploadScreens.click();
                    }
                    this.$refs.pop.hide();
                });
            } else {
                this.$toast.showNotify({
                    type: "warning",
                    message: this.$t("userInterface.importInterfaceReadonlyMode")
                });
            }
        },
        updateInterface() {
            this.$root.$emit("nodeClicked");
            if (!this.$oneAtATime.state.$currentRoomEmpty) {
                this.loadInterface({ guid: this.activeInterface, update: true });
            }
        },
        exportInterface() {
            let exportInterface;
            if (this.appInterfaces.length && this.activeInterface) {
                this.interfaceName = this.currentInterfaceProperties.name;
                if (this.emptyInterface.name || this.emptyInterface.code) {
                    this.interfaceName = this.emptyInterface.name || this.emptyInterface.code;
                }
                this.saveInterface("exportDraft").then((data1) => {
                    let fragments;
                    if (data1.interfaceJson.config.fragments.length) {
                        fragments = `["${data1.interfaceJson.config.fragments.join('","')}"]`;
                    }

                    exportInterface = { ...data1, fragments };
                    if (exportInterface) {
                        this.exportInterfaceAction(exportInterface).then(data => {
                            if (data && data.data) {
                                this.interfaceData = JSON.stringify(data.data);
                                if (data.data.fragments && data.data.fragments.length) {
                                    this.hasFragments = true;
                                } else {
                                    this.$saveFileAs(`${this.interfaceName || "new_interface"}.json`, this.interfaceData);
                                    this.updateInterface();
                                }
                            }
                        });
                    }
                });
            }
        },
        cancelAction() {
            this.hasFragments = false;
            this.resetFileInput();
        },
        okAction() {
            if (this.importedInterfaceName) {
                this.hasFragments = false;
                this.importInterface(this.importedData).then(() => {
                    this.getLatestAppInterfaces().then(interfaces => {
                        interfaces.forEach(element => {
                            if (element.code === this.importedData.code) {
                                this.setActiveInterface(element.id);
                            }
                        });
                        const payload = {
                            guid: this.activeInterface,
                            update: true
                        };
                        this.$store.commit("components/setReadonly", false);
                        this.loadInterface(payload);
                        this.$toast.showNotify({
                            type: "success",
                            message: this.$t("userInterface.importInterface"),
                            code: "qfs-removeIOk",
                            timeout: 2000
                        });
                    });
                });
                this.draft = false;
                this.importedInterfaceName = "";
                this.resetFileInput();
            } else {
                this.$saveFileAs(`${this.interfaceName || "new_interface"}.json`, this.interfaceData);
                this.updateInterface();
                this.hasFragments = false;
            }
        },
        nodeClick(node) {
            this.$root.$emit("deletedInterface", false);
            this.$root.$emit("nodeClicked");
            if (node.id !== this.activeInterface) {
                this.$store.commit("main/setSaveBtnVisible", this.readonlyPermission);
                this.$root.$emit("setReadonlyTag", this.readonlyPermission);
            }
            this.$store.commit("components/setReadonly", !this.$oneAtATime.state.$currentRoomEmpty);
            this.addClick = 0;
            if (!node.id || this.currentInterfaceProperties.id === node.id) { // click on the same interface
                this.node = node;
            } else if (this.draft && this.interfaceDirty) { // click another node interface while in draft mode
                this.node = node;
                this.openDialog = true;
            } else { // load the content for clicked interface if there are no modif on current interface
                this.validateChangeAction().then(data => {
                    if (data) {
                        const payload = {
                            guid: node.id,
                            update: true
                        };
                        this.loadInterface(payload);
                    }
                });
            }
        },
        validateChangeAction() {
            return new Promise(resolve => {
                this.checkForModifications().then(data => {
                    if (data) {
                        this.$confirm(this.$t("userInterface.leavePageMsg"), this.$t("userInterface.confirm"), this.$t("userInterface.continue"))
                            .then(() => resolve(true))
                            .catch(() => resolve(false));
                    } else {
                        resolve(true);
                    }
                });
            });
        },
        checkForModifications() {
            return new Promise(resolve => {
                if (this.activeInterface) {
                    const { _details = {}, type, code, name, description } = this.currentInterfaceProperties;
                    const { type: iType, code: iCode, name: iName, description: iDescription } = _details;
                    if (this.activeInterface === "draft") {
                        resolve(true);
                    } else if (type !== iType || code !== iCode || name !== iName || ((description || "") !== (iDescription || ""))) {
                        resolve(true);
                    } else {
                        const original = this.currentInterfaceModel;
                        const differences = diff(original, this.properties);

                        resolve(Object.keys(differences).length > 0);
                    }
                } else {
                    resolve(Object.keys(this.properties).length > 0);
                }
            });
        },
        loadInterface(payload, showSave) {
            const gui = payload.guid || payload;
            this.selected = gui;
            this.getInterfaceModel(payload).then(data => {
                if (data && data.properties) {
                    this.$root.$emit("hideSaveBtn", false);
                    // ToDo: check this
                    this.$root.$emit("showCheckedSaveBtn", typeof showSave !== "boolean");
                    this.$root.$emit("showPublish", { noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses")
                        ? !this.currentApp.nrOfProcesses : !this.processList.length,
                    showPublish: this.publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
                    this.$store.commit("components/updateAppInterface", { guid: data.properties.id, data: data.properties });
                }
                this.__resetColors();
                const components = (data.model && data.model.interfaceJson) || { components: {}, body: [] };

                if (components.hasOwnProperty("config") && components.config.hasOwnProperty("theme")) {
                    this.__loadThemeObject(components.config.theme);
                }
                this.__loadInterfaceFromJSON(components);
                this.setActiveInterface(gui);
            });
        },
        removeInterface() {
            if (!this.readOnly) {
                const gui = this.activeInterface === "draft" ? this.emptyInterface.id : this.currentInterfaceProperties.id;
                if (gui) {
                    this.guiRemove(gui)
                        .then(() => {
                            this.$toast.showNotify({
                                type: "success",
                                message: this.$t("userInterface.interfaceRemoved"),
                                code: "qfs-removeIOk",
                                timeout: 2000
                            });
                            this.clearInterface();
                        });
                } else {
                    this.$store.commit("components/removeAppInterface", gui);
                    this.$toast.showNotify({
                        type: "success",
                        message: this.$t("userInterface.interfaceRemoved"),
                        code: "qfs-removeIOk",
                        timeout: 2000
                    });
                    this.draft = false;
                    this.clearInterface();
                }
            }
        },
        editNode() {
            this.modalInterfaceDetails = true;
        },
        clearInterface() {
            this.resetInterface();
            this.selected = null;
            this.$nextTick(() => {
                this.__resetColors();
            });
            this.$store.commit("main/setSaveBtnVisible", true);
            this.$store.commit("components/setReadonly", true);
        },

        addInterfaceList() {
            this.$root.$emit("hideSaveBtn", false);
            this.$root.$emit("showPublish", { noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses")
                ? !this.currentApp.nrOfProcesses : !this.processList.length,
            showPublish: this.publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
            this.$store.commit("main/setSaveBtnVisible", false);
            this.setReadonly(false);

            this.resetInterface("draft");
            this.$store.commit("components/addAppInterface", this.emptyInterface);
            this.$store.commit("main/setInterfaceDirty", true);
            this.selected = null;
            this.$nextTick(() => {
                this.__resetColors();
            });
            this.draft = true;
        },

        addInterface() {
            this.addClick += 1;
            this.checkForModifications().then(data => {
                this.hasChanges = data;
                if (this.hasChanges || this.draft) { // if  user already has an interface in draft mode or has unsaved modif on interface
                    this.wrnMessage = this.$t("documents.draftMessage");
                    this.openDialog = true;
                } else {
                    this.addInterfaceList();
                }
            });
        },
        setSelectedInterface(guid) {
            this.loadInterface(guid);
        },
        okActionDraft() {
            if (this.hasChanges && this.addClick === 1) { // when user add a new interface while being in edit mode on another  interface
                this.addInterfaceList();
            } else if (this.addClick > 1) { // multiple click on + case
                this.$store.commit("components/emptyBody");
                this.resetInterface("draft");
            } else { // click another node interface while being in draft mode
                this.$store.commit("components/removeAppInterface", this.activeInterface);
                this.draft = false;
                this.$store.commit("main/setInterfaceDirty", false);
                this.loadInterface(this.node.id);
            }
            this.openDialog = false;
        },
        cancelActionDraft() {
            this.openDialog = false;
            if (this.addClick) {
                this.addClick -= 1;
            }
        },
        focusSelectedInterface() {
            const focusedInt = document.getElementById(`idInt-${this.selected}`);
            if (focusedInt) {
                focusedInt.scrollIntoView(true);
            }
        }
    }
};
